<template>
  <v-app>
    <core-filter />
    <router-view />
  </v-app>
</template>
<script>
import { mapState } from 'vuex'
import CoreFilter from '@/components/core/menu.vue'

export default {
  components: {
    CoreFilter
  },
  data: () => ({}),
  mounted: function() {},
  computed: {
    ...mapState({
      user: state => state.user,
      base: state => state.base
    })
  },
  methods: {}
}
</script>
